'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';
import { GoArrowUpRight } from 'react-icons/go';
import ModalPortal from '@/components/ModalPortal';
import Link from 'next/link';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type Journal = {
  id: string;
  name?: string;
  awards_text?: string;
  date?: string;
  button: {
    button_text: string;
    button_url: string;
  };
  media?: {
    desktop_media?: { url: string }[];
  };
  description?: { children?: { text: string }[] }[];
};

interface JournalModalProps {
  journal: Journal;
  onClose: () => void;
}
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

// const getPlainText = (desc: Journal['description'] = []) =>
//   desc.map((block) => block?.children?.map((child) => child?.text || '').join('') ?? '').join('\n');

export default function JournalModal({ journal, onClose }: JournalModalProps) {
  return (
    <ModalPortal>
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-[1000]"
          onClick={onClose}
        />
        {/* <div className="fixed inset-0 bg-black bg-opacity-50 z-[1000]" onClick={onClose} /> */}
        <motion.div
          initial={{ x: '-100%' }}
          animate={{ x: 0, transition: { duration: 0.3, ease: 'easeOut' } }}
          exit={{ x: '-100%', transition: { duration: 0.3, ease: [0.77, 0, 0.175, 1] } }}
          className="fixed top-0 left-0 w-full md:w-[400px] h-full bg-[#2B332A] shadow-lg z-[1100] px-4 py-6 pb-0 overflow-y-auto custom-scroll"
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col h-full">
            <div className="flex justify-between items-center mb-16 text-[15px] font-light leading-none">
              <h2 className="text-[#B6C380]">News</h2>
              <button
                onClick={onClose}
                className="text-[#B6C380] hover:text-white"
                aria-label="Close modal"
              >
                Close
              </button>
            </div>

            <h3 className="text-xl text-[#E5E1D5] mb-6 leading-6 font-light">{journal.name}</h3>

            <Image
              src={journal.media?.desktop_media?.[0]?.url || '/images/fallback.jpg'}
              alt="Journal article"
              width={471}
              height={343}
              className="w-full h-auto"
            />

            <div className="text-[#E5E1D5] pt-8 pb-4 whitespace-pre-wrap text-[15px] leading-[20px] font-light blocksRenderer">
              {/* {getPlainText(journal.description)} */}
              <BlocksRenderer content={journal?.description as BlocksRendererProps['content']} />
            </div>

            {journal?.button?.button_text && (
              <Link
                href={journal?.button?.button_url}
                className="text-[#B6C380] mt-auto pb-6 hover:text-white flex items-center gap-1 text-[16px] leading-none font-light"
              >
                {journal?.button?.button_text} <GoArrowUpRight />
              </Link>
            )}
          </div>
        </motion.div>
      </>
    </ModalPortal>
  );
}
